import React, { useMemo } from 'react';

import {
  COLUMN_ISSUES_TOAST,
  INVALID_ROWS_TOAST,
  REPAIR_ADDRESSES_SUCCESS_TOAST,
} from '../../../../../constants/addressBook';
import NotificationAlert, { AlertDescription } from '../../../../_mui/_alerts_/NotificationAlert';
import ToastWrapper from '../ToastWrapper/ToastWrapper';

interface IProps {
  hasUnmappedColumns: boolean;
  amountOfIssues: number;
  showIssuesOnly: boolean;
  invalidRowsCount: number;
  isRepairStep: boolean;
  hasInvalidRows: boolean;
  onShowIssuesOnly: () => void;
  hasRows: boolean;
}

const StepToast: React.FC<IProps> = ({
  hasUnmappedColumns,
  amountOfIssues,
  showIssuesOnly,
  invalidRowsCount,
  isRepairStep,
  hasInvalidRows,
  onShowIssuesOnly,
  hasRows,
}) => {
  const hasInvalidRowsAndFullView = useMemo(() => {
    return isRepairStep && hasInvalidRows && !showIssuesOnly;
  }, [isRepairStep, hasInvalidRows, showIssuesOnly]);

  const allRowsValid = useMemo(() => {
    return isRepairStep && !hasInvalidRows && !showIssuesOnly && hasRows;
  }, [isRepairStep, hasInvalidRows, showIssuesOnly, hasRows]);

  switch (true) {
    case hasUnmappedColumns:
      return (
        <ToastWrapper>
          <NotificationAlert type={COLUMN_ISSUES_TOAST.type}>
            <AlertDescription>{COLUMN_ISSUES_TOAST.description(amountOfIssues)}</AlertDescription>
          </NotificationAlert>
        </ToastWrapper>
      );
    case hasInvalidRowsAndFullView:
      return (
        <ToastWrapper>
          <NotificationAlert
            type={INVALID_ROWS_TOAST.type}
            actionButtonText={INVALID_ROWS_TOAST.buttonText}
            actionOnClick={onShowIssuesOnly}
            sx={{ width: '100%', alignItems: 'center' }}
            actionSx={{
              ml: 0,
              pl: 0,
              pt: 0,
              '& .MuiButton-root': {
                fontSize: '14px !important',
              },
            }}
          >
            <AlertDescription>{INVALID_ROWS_TOAST.description(invalidRowsCount)}</AlertDescription>
          </NotificationAlert>
        </ToastWrapper>
      );
    case allRowsValid:
      return (
        <ToastWrapper>
          <NotificationAlert type={REPAIR_ADDRESSES_SUCCESS_TOAST.type} sx={{ width: '100%' }}>
            <AlertDescription>{REPAIR_ADDRESSES_SUCCESS_TOAST.description}</AlertDescription>
          </NotificationAlert>
        </ToastWrapper>
      );
    default:
      return null;
  }
};

export default StepToast;
